module.exports = __webpack_public_path__ + "img/CRM-No-Relations.3dd6ef8d.svg";